import React from 'react';
import { arrivalLineColor, closureLineColor } from '../../../constants/colors';
import AdmCumulativeChartWrapper from '../adm_shared/AdmCumulativeChartWrapper';

export default function AdmCumulativeChart(props) {
  const { arrival, closure, increment, d0_date, d2_date } = props;

  return (
    <AdmCumulativeChartWrapper
      title='Cumulative Defect Prediction'
      arrival={arrival}
      closure={closure}
      increment={increment}
      d0_date={d0_date}
      d2_date={d2_date}
      arrivalColor={arrivalLineColor}
      closureColor={closureLineColor}
      showArrival={true}
      showClosure={true}
    />
  );
}
